import { yupResolver } from '@hookform/resolvers/yup';
import CloseIcon from '@mui/icons-material/Close';
import { DialogTitle, IconButton, DialogContent, Box, Grid, DialogActions } from '@mui/material';
import { FormProvider, useForm } from 'react-hook-form';
import {
  WsDialog,
  WsDialogSize,
  WsButton,
  WsTypography,
  WsTypoVariants,
  ControlledTextArea,
  ControlledTextInput,
} from 'wisestep-base';

import { promptSchema } from '../../../schemas';

export interface IPromptDialog {
  defaultValues;
  openPromptDialog: boolean;
  handleOpenPromptDialogForEdit: () => void;
  onSave: (value) => void;
}

export const PromptDialog = ({
  defaultValues,
  openPromptDialog,
  handleOpenPromptDialogForEdit,
  onSave,
}: IPromptDialog) => {
  const methods = useForm({
    defaultValues: defaultValues,
    resolver: yupResolver(promptSchema),
  });
  const { handleSubmit } = methods;
  const handleFormSubmit = (data) => {
    onSave(data);
  };
  return (
    <FormProvider {...methods}>
      <WsDialog openDialog={openPromptDialog} size={WsDialogSize.MEDIUM}>
        <DialogTitle
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <WsTypography variant={WsTypoVariants.SUB_TITLE} bold>
            Add Prompt - Auto-reply
          </WsTypography>
          <IconButton onClick={handleOpenPromptDialogForEdit} size="small">
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent
          sx={{
            backgroundColor: '#EAEAF1',
            alignItems: 'center',
          }}
        >
          <Grid
            container
            spacing={1}
            sx={{
              backgroundColor: 'white',
              mt: 2.5,
              p: 1,
            }}
          >
            <Grid item xs={12}>
              <ControlledTextInput
                name="promptTitle"
                labelText="Prompt Title"
                showMandatorySymbol={true}
                placeholder="Enter title"
                sx={{
                  minWidth: '60%',
                  '& .MuiInputBase-input': {
                    height: 14,
                    p: 0,
                  },
                }}
              />
            </Grid>
            <Grid item xs={11}>
              <ControlledTextArea
                name="prompt"
                labelText="Prompt"
                showMandatorySymbol={true}
                placeholder="Write prompt to ChatGPT"
                minRows={6}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions
          sx={{
            alignItems: 'center',
            p: 1,
          }}
        >
          <Box mr={2}>
            <WsButton size="large" variant="contained" onClick={handleSubmit(handleFormSubmit)}>
              save
            </WsButton>
          </Box>
        </DialogActions>
      </WsDialog>
    </FormProvider>
  );
};
